import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";

import FieldworkerAvailabilityForm from "../components/FieldworkerAvailabilityForm";

export default function FieldworkerAvailabilityScreen() {
    const { t } = useTranslation("fieldworker");
    return (
        <GaiaPageLayoutColumn>
            <GaiaPageComponent title={t("fieldworkerAvailabilityScreen.availabilityTitle")} sx={{ marginBottom: 2 }}>
                <Typography variant="body1">{t("fieldworkerAvailabilityScreen.availabilityContent1")}</Typography>
                <br />
                <Typography variant="body1">{t("fieldworkerAvailabilityScreen.availabilityContent2")}</Typography>
                <br />
                <Typography variant="body1">{t("fieldworkerAvailabilityScreen.availabilityContent3")}</Typography>
                <br />
                <Typography variant="body1">
                    <strong>{t("fieldworkerAvailabilityScreen.availabilityAttention")}</strong>
                    {t("fieldworkerAvailabilityScreen.availabilityContent4")}
                </Typography>

                <FieldworkerAvailabilityForm />
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
